const enableMocking = async () => {
  if (!import.meta.env.DEV && !import.meta.env.STORYBOOK) {
    return;
  }
  const { worker } = await import("./browser");
  const { registerMockPcaButton } = await import("./pca-button");
  registerMockPcaButton();
  window.mindShiftNav = window.mindShiftNav || {};
  window.mindShiftNav.isOneCxEnabled = true;

  // Serve from root during local dev
  let serviceWorkerUrl = import.meta.env.DEV ? "/mockServiceWorker.js" : "/r/shops/slider/mockServiceWorker.js";

  if (import.meta.env.STORYBOOK) {
    // When running Storybook locally, the service worker is located at the root
    // In production Storybook, it's served under /storybook
    const isStorybookProduction = !import.meta.env.DEV && window.location.pathname.startsWith("/storybook");
    serviceWorkerUrl = isStorybookProduction ? "/storybook/mockServiceWorker.js" : "/mockServiceWorker.js";
  }

  return worker.start({
    serviceWorker: {
      url: serviceWorkerUrl,
      options: {
        scope: "/", // Enables MSW mocking across all routes (/p/, /r/, etc.)
      },
    },
  });
};

export default enableMocking;
